import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function CaseStudies() {
  const { t } = useTranslation('home');
  const [selectedCase, setSelectedCase] = useState<number | null>(null);

  const cases = [
    {
      id: 1,
      title: t('caseStudies.cases.0.title'),
      image: 'https://readdy.ai/api/search-image?query=Modern%20industrial%20safety%20management%20control%20room%20with%20multiple%20monitoring%20screens%20displaying%20real-time%20safety%20data%2C%20clean%20white%20and%20blue%20interface%2C%20professional%20lighting%2C%20high-tech%20atmosphere%2C%20minimalist%20design&width=800&height=600&seq=case1&orientation=landscape',
      category: t('caseStudies.cases.0.category'),
      description: t('caseStudies.cases.0.description'),
      highlights: [
        t('caseStudies.cases.0.highlights.0'),
        t('caseStudies.cases.0.highlights.1'),
        t('caseStudies.cases.0.highlights.2'),
        t('caseStudies.cases.0.highlights.3')
      ],
      results: t('caseStudies.cases.0.results')
    },
    {
      id: 2,
      title: t('caseStudies.cases.1.title'),
      image: 'https://readdy.ai/api/search-image?query=Advanced%20quality%20control%20laboratory%20with%20precision%20testing%20equipment%20and%20digital%20displays%2C%20clean%20white%20environment%2C%20modern%20manufacturing%20quality%20inspection%20scene%2C%20professional%20industrial%20setting%2C%20bright%20lighting&width=800&height=600&seq=case2&orientation=landscape',
      category: t('caseStudies.cases.1.category'),
      description: t('caseStudies.cases.1.description'),
      highlights: [
        t('caseStudies.cases.1.highlights.0'),
        t('caseStudies.cases.1.highlights.1'),
        t('caseStudies.cases.1.highlights.2'),
        t('caseStudies.cases.1.highlights.3')
      ],
      results: t('caseStudies.cases.1.results')
    },
    {
      id: 3,
      title: t('caseStudies.cases.2.title'),
      image: 'https://readdy.ai/api/search-image?query=Modern%20tire%20manufacturing%20production%20line%20with%20automated%20machinery%20and%20robotic%20systems%2C%20clean%20industrial%20environment%2C%20smart%20factory%20with%20digital%20monitoring%20screens%2C%20bright%20professional%20lighting%2C%20high-tech%20atmosphere&width=800&height=600&seq=case3&orientation=landscape',
      category: t('caseStudies.cases.2.category'),
      description: t('caseStudies.cases.2.description'),
      highlights: [
        t('caseStudies.cases.2.highlights.0'),
        t('caseStudies.cases.2.highlights.1'),
        t('caseStudies.cases.2.highlights.2'),
        t('caseStudies.cases.2.highlights.3')
      ],
      results: t('caseStudies.cases.2.results')
    },
    {
      id: 4,
      title: t('caseStudies.cases.3.title'),
      image: 'https://readdy.ai/api/search-image?query=Large%20modern%20automated%20warehouse%20with%20intelligent%20storage%20systems%2C%20robotic%20arms%2C%20organized%20inventory%20shelves%2C%20digital%20management%20displays%2C%20clean%20industrial%20space%2C%20bright%20overhead%20lighting%2C%20futuristic%20logistics%20center&width=800&height=600&seq=case4&orientation=landscape',
      category: t('caseStudies.cases.3.category'),
      description: t('caseStudies.cases.3.description'),
      highlights: [
        t('caseStudies.cases.3.highlights.0'),
        t('caseStudies.cases.3.highlights.1'),
        t('caseStudies.cases.3.highlights.2'),
        t('caseStudies.cases.3.highlights.3')
      ],
      results: t('caseStudies.cases.3.results')
    },
    {
      id: 5,
      title: t('caseStudies.cases.4.title'),
      image: 'https://readdy.ai/api/search-image?query=Smart%20manufacturing%20workshop%20with%20advanced%20production%20equipment%2C%20digital%20control%20panels%2C%20automated%20assembly%20lines%2C%20clean%20modern%20factory%20floor%2C%20professional%20industrial%20lighting%2C%20high-tech%20manufacturing%20environment&width=800&height=600&seq=case5&orientation=landscape',
      category: t('caseStudies.cases.4.category'),
      description: t('caseStudies.cases.4.description'),
      highlights: [
        t('caseStudies.cases.4.highlights.0'),
        t('caseStudies.cases.4.highlights.1'),
        t('caseStudies.cases.4.highlights.2'),
        t('caseStudies.cases.4.highlights.3')
      ],
      results: t('caseStudies.cases.4.results')
    },
    {
      id: 6,
      title: t('caseStudies.cases.5.title'),
      image: 'https://readdy.ai/api/search-image?query=Modern%20business%20collaboration%20office%20with%20digital%20screens%20showing%20supplier%20management%20dashboards%2C%20clean%20professional%20workspace%2C%20bright%20natural%20lighting%2C%20contemporary%20corporate%20environment%2C%20minimalist%20design&width=800&height=600&seq=case6&orientation=landscape',
      category: t('caseStudies.cases.5.category'),
      description: t('caseStudies.cases.5.description'),
      highlights: [
        t('caseStudies.cases.5.highlights.0'),
        t('caseStudies.cases.5.highlights.1'),
        t('caseStudies.cases.5.highlights.2'),
        t('caseStudies.cases.5.highlights.3')
      ],
      results: t('caseStudies.cases.5.results')
    }
  ];

  const closeModal = () => {
    setSelectedCase(null);
  };

  const selectedCaseData = cases.find(c => c.id === selectedCase);

  return (
    <section id="cases" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('caseStudies.title')}</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('caseStudies.subtitle')}
          </p>
        </div>

        {/* Cases Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cases.map((caseItem) => (
            <div
              key={caseItem.id}
              onClick={() => setSelectedCase(caseItem.id)}
              className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-64 overflow-hidden">
                <img
                  src={caseItem.image}
                  alt={caseItem.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block px-3 py-1 bg-indigo-500 text-white text-xs rounded-full mb-2">
                    {caseItem.category}
                  </span>
                  <h3 className="text-white font-medium text-center">{caseItem.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedCase && selectedCaseData && (
        <div 
          className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <div 
            className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="relative w-full h-80">
              <img
                src={selectedCaseData.image}
                alt={selectedCaseData.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
              <button
                onClick={closeModal}
                className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full text-white backdrop-blur-sm transition-all duration-300 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <span className="inline-block px-4 py-1.5 bg-indigo-500 text-white text-sm rounded-full mb-3">
                  {selectedCaseData.category}
                </span>
                <h2 className="text-3xl font-bold text-white mb-2">{selectedCaseData.title}</h2>
              </div>
            </div>

            {/* Modal Content */}
            <div className="p-8">
              <div className="mb-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4">{t('caseStudies.projectOverview')}</h3>
                <p className="text-gray-600 leading-relaxed">{selectedCaseData.description}</p>
              </div>

              <div className="mb-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4">{t('caseStudies.coreFeatures')}</h3>
                <div className="grid grid-cols-2 gap-4">
                  {selectedCaseData.highlights.map((highlight, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <div className="w-2 h-2 flex items-center justify-center bg-indigo-500 rounded-full"></div>
                      <span className="text-gray-700">{highlight}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{t('caseStudies.implementationResults')}</h3>
                <p className="text-gray-700 leading-relaxed">{selectedCaseData.results}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
